export { PhoneConsent } from './phone-consent.component';
export { GeneralTermsAndCreditCheck } from './general-terms-and-credit-check.component';
export { ContractLink } from './contract-link.component';
export { ConsentLink } from './consent-link.component';
